<template>
    <form @submit.prevent="useAuthTwoFactor">
        <div class="account-body">
            <div class="page-info">안전한 계정 보호를 위해 2단계 인증을 진행합니다. <br><strong>'인증수단과 위치'</strong>를 선택해주세요.</div>
            <div class="compo-form-items">
                <div class="compo-form-item">
                    <div class="compo-form-name">
                        <label class="compo-form-title">인증수단</label>
                    </div>
                    <div class="compo-form-body__choice-box">
                        <div class="choice-item__icon">
                            <input type="radio" class="buttonbox" id="authPhoneNum" value="MOBILE_PHONE" name="checkedOptionAuthTwoFactor" v-model="checkedOptionAuthTwoFactor"
                                @click="changeCheckedOption($event)">
                            <label class="label-checkbox__icon" for="authPhoneNum"> 
                                <IconPhone></IconPhone>
                                휴대폰 번호 인증
                            </label>
                        </div>
                        <div class="choice-item__icon">
                            <input type="radio" class="buttonbox" id="authEmailAdress" value="EMAIL" name="checkedOptionAuthTwoFactor" v-model="checkedOptionAuthTwoFactor"
                                @click="changeCheckedOption($event)">
                            <label class="label-checkbox__icon" for="authEmailAdress">
                                <IconEmail></IconEmail>
                                이메일 주소 인증
                            </label>
                        </div>
                    </div>
                    <template v-if="!isCertifiedNum">
                        <div class="compo-form-body">
                            <template v-if="!certNumTimer">
                                <button type="button" class="btn-l btn-p w-100" @click="sendCertNum">인증번호 발송</button>
                            </template>
                            <template v-else>
                                <div class="form-item mb-0">
                                    <div class="form-flex position-relative form-time-limit" ref="phoneCert" id="form-time-limit-phoneNum">
                                        <input type="tel" class="form-control" ref="certNum" id="cert-num-phoneNum" placeholder="인증코드 6자리 입력" maxlength="6" v-model="certNum" :disabled="isCertifiedNum">
                                        <span class="cert-limit position-absolute" ref="certNumTimeLimit" id="cert-limit-phoneNum">{{certNumTimeLimitMinSec}}</span>
                                        <button class="btn-m btn-p" @click.prevent="confirmCertNum" :disabled="isCertifiedNum"><strong>확인</strong></button>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>
                    <template v-if="messageResultVaildTest">
                        <div class="compo-form-body">
                            <p class="form-info justify-content-center" :class="{'active': messageResultVaildTest, 'success': messageSuccess}">{{messageResultVaildTest}}</p>
                        </div>
                    </template>
                    <template v-if="!isCertifiedNum">
                        <div class="txt-route">인증번호가 오지 않나요? <router-link to="/">고객센터 문의</router-link></div>
                    </template>
                </div>
                <div class="compo-info-box">
                    - 이메일 또는 휴대폰번호가 최신이 아니라면 아래 문의처로 수정 요청해주세요.<br>
                    - 인증수단 정보는 회원정보수정에서 수정이 가능합니다.
                </div>
            </div>
            <div class="txt-route mt-0">문제가 있으시다면? <router-link to="/">고객센터 문의</router-link></div>
            <div class="btns w-100">
                <button type="sumit" class="btn-l btn-p" :disabled="!isCertifiedNum">사용하기</button>
            </div>
        </div>
    </form>
</template>

<script>
import { mapState } from 'vuex';
export default {
    components: {
        IconPhone: () => import('@/components/svg-icon/IconPhone.vue'), // 휴대폰 아이콘
        IconEmail: () => import('@/components/svg-icon/IconEmail.vue'), // 이메일 아이콘
    },

    props: {    
        isAuthTwoFactor: {    // 2단계 인증 사용 여부 
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            authReqCode : 'TOW_FACTOR_AUTH',                // 인증요청 타입(2단계 인증)
            checkedOptionAuthTwoFactor: 'MOBILE_PHONE',     // 2단계 인증 수단 (이메일 or 휴대폰번호)
            certNum: null,                                  // 인증번호
            certNumTimer: 0,                                // 인증번호 타이머
            certNumTimeLimit: 180,                          // 휴대폰 인증 제한 시간(3분)
            messageResultVaildTest: '',                     // 유효성 검사 메시지 - 인증번호
            messageSuccess: false,                          // 유효성 검사 성공 여부
            isCertifiedNum: false,                          // 인증번호 인증 여부

            // 백엔드에서 가져오는 Data
            phoneNum: '01020012789',                        // 휴대폰 번호
            email: 'krkim@tscientific.co.kr',               // 이메일 주소
        }
    },

    created(){
    }
,
    computed: {
        ...mapState({
            userNo: state => state.userNo,
            authentication: state => state.authentication,
            vuexTowFactorAuthCode: state => state.vuexTowFactorAuthCode,
            // userData: state => state.userData, 
        }),	

        // 선택한 2단계 인증 요소 데이터 값 (이메일 주소 or 휴대폰번호)
        dataOfCheckedAuthTwoFactor(){
            const optioin = this.checkedOptionAuthTwoFactor;
            return optioin === 'MOBILE_PHONE' ? this.phoneNum : (optioin === 'EMAIL' ? this.email : null);
        },

        // 휴대폰 인증번호 타임 리미트 동작시 인증 타이머 카운터 (카운트 감소 동작)
        certNumTimeLimitMinSec() {
            return Math.floor(this.certNumTimeLimit / 60) + ':' + (this.certNumTimeLimit % 60 < 10 ? '0'+ this.certNumTimeLimit % 60 : this.certNumTimeLimit % 60);
        },
    },

    methods: {
        
        // 요소에 접근하여 포커싱하기
        focusOnWarning(element, className){
            element.focus();
            if(className === 'warning'){
                element.classList.add(className);
            }
        },

        // 메세지 노출
        displayMessageResultVaildTest(messageTxt, success){
            this.messageSuccess = success;
            this.messageResultVaildTest = messageTxt;
        },
        
        // 인증 수단 옵션 클릭 시 
        changeCheckedOption(event) {
            this.checkedOptionAuthTwoFactor = event.currentTarget.value;

            this.certNumTimer = 0;                          // 타이머 초기화
            this.isCertifiedNum = false                     // 인증여부 초기화
            this.displayMessageResultVaildTest('', false);  // 안내 메시지 초기화
        },

        // 인증번호 발송 버튼 클릭 : 유효성 검사 여부, 휴대폰 or 이메일 인증번호 발송
        sendCertNum() {
            this.displayMessageResultVaildTest('인증번호를 발송하고 있습니다. 잠시만 기다려주세요.', true);

            // 인증번호 발송 요청
            this.$http({
                method: 'post',
                url: '/api/v1/auth/send',
                data: {
                    "authKey": this.dataOfCheckedAuthTwoFactor,
                    "authReqCode": this.authReqCode,
                    userNo: this.userNo
                }
            })
            .then(res => {
                if (res.status == 200 || res.status == 204) {
                    /* 동일번호 재발송 오류메시지 이후에도 카운트다운은 기존대로 지속  */
                    // 타이머가 있다면 초기화
                    if (this.certNumTimer) {
                        clearInterval(this.certNumTimer);
                    }
                    // 타이머 제한시간 리셋
                    this.certNumTimeLimit = 180;

                    // 타이머 시작
                    this.certNumTimer = setInterval(() => {
                        if (this.certNumTimeLimit > 0) {
                            this.certNumTimeLimit--;
                        } else {
                            clearInterval(this.certNumTimer);
                        }
                    }, 1000);
                    // document.querySelector('#cert-num-phoneNum').focus();
                    this.displayMessageResultVaildTest('인증번호가 발송되었습니다.', true);
                    return;
                } else {
                    const err = new Error();
                    err.response = res;
                    throw err;
                }
            })
            .catch(err => {
                this.messageSuccess = false; // 초기화
                if (err &&
                    err.response &&
                    err.response.data &&
                    err.response.data.status &&
                    err.response.data.status == 400) {
                    
                    this.displayMessageResultVaildTest(`${err.response.data.message}`, false);
                    return;
                }
            })
        },        

        // 인증번호 확인 버튼 클릭: 인증번호 확인
        confirmCertNum() {
            if (!this.certNum) {
                // document.querySelector('#cert-num').focus();
                this.displayMessageResultVaildTest('인증번호 6자리를 입력해주세요.', false);
                return;
            }

            // 인증번호 확인 요청
            this.$http({
                method: 'post',
                url: '/api/v1/auth/check',
                data: {
                    "authKey": this.dataOfCheckedAuthTwoFactor,
                    "authNo": this.certNum,
                    "authReqCode": this.authReqCode,
                    userNo: this.userNo
                }
            })
            .then(res => {
                if (res.status == 200 || res.status == 204) {
                    // 타이머 정지
                    clearInterval(this.certNumTimer);
                    
                    // 타이머 초기화 & 인증번호 입력폼 숨김
                    this.certNumTimer = null;

                    // 인증여부 저장
                    this.isCertifiedNum = true;
                    this.isCertifiedBtnDisabled = true;

                    this.displayMessageResultVaildTest('본인 인증이 완료되었습니다.', true);
                    return;
                } else {
                    const err = new Error();
                    err.response = res;
                    throw err;
                }
            })
            .catch(err => {
                this.messageSuccess = false; // 초기화

                if (err &&
                    err.response &&
                    err.response.data &&
                    err.response.data.status &&
                    err.response.data.status == 400) {

                    this.displayMessageResultVaildTest(`${err.response.data.message}`, false);
                    return;
                }
            })
        },

        // 2단계 인증 사용하기
        useAuthTwoFactor(){
            this.$http({
                method: 'post',
                url: '/api/v1/users/updateTowFactorAuthCode',
                data: {
                    "towFactorAuthCode": this.checkedOptionAuthTwoFactor,
                    userNo: this.userNo
                }
            })
            .then(res => {
                if (res.status == 200 || res.status == 204) {

                    // 2단계 인증 사용여부 전달
                    this.$store.commit('setVuexTowFactorAuthCode', this.checkedOptionAuthTwoFactor);
                    return;
                } else {
                    const err = new Error();
                    err.response = res;
                    throw err;
                }
            })
            .catch(err => {
                if (err &&
                    err.response &&
                    err.response.data &&
                    err.response.data.status &&
                    err.response.data.status == 400) {

                    alert(`${err.response.data.message}`);
                    return;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/account.scss';
</style>